import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { SubscriptionPlan } from '@vi-iot/client';

import {
  ActiveErrorsStore,
  DiagStackOtxStore,
  InstallationDetailsStore,
  Platform,
  RemoteDiagnosticsStore,
  VddDetailsListStore,
} from '@store';

import {
  ActiveErrorDetailsSections,
  dataAtTheTimeOfFaultDetectionVddName,
} from '../guided-troubleshooting.model';

@Component({
  selector: 'app-active-error-diagnostics',
  templateUrl: './active-error-diagnostics.component.html',
  styleUrls: ['./active-error-diagnostics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveErrorDiagnosticsComponent implements OnInit, OnDestroy {
  readonly platform = Platform;
  readonly subscriptionPlan = SubscriptionPlan;
  readonly activeErrorDetailsSections = ActiveErrorDetailsSections;

  gatewaySerial: string = this.activatedRoute.snapshot.queryParams.gatewaySerial;
  isActiveSessionAvailable: boolean;
  dataAtTheTimeOfFaultDetectionError$: Observable<boolean>;
  isAnyOfTheOtxVddSequenceInError$: Observable<boolean>;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    public installationDetailsStore: InstallationDetailsStore,
    public activeErrorsStore: ActiveErrorsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private vddDetailsListStore: VddDetailsListStore,
    private diagStackOtxStore: DiagStackOtxStore
  ) {}

  ngOnInit(): void {
    this.remoteDiagnosticsStore
      .isActiveSessionAvailable(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isActiveSessionAvailable) => {
        this.isActiveSessionAvailable = isActiveSessionAvailable;
        this.cdr.detectChanges();
      });

    this.remoteDiagnosticsStore
      .getLogicalLinkOfSelectedActiveError(this.gatewaySerial)
      .pipe(take(1))
      .subscribe(
        (logicalLink) =>
          (this.dataAtTheTimeOfFaultDetectionError$ = this.vddDetailsListStore.isVddReadInErrorState(
            dataAtTheTimeOfFaultDetectionVddName,
            logicalLink
          ))
      );

    this.isAnyOfTheOtxVddSequenceInError$ = this.diagStackOtxStore.isAnyOfTheOtxVddSequenceInError$;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
